import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-simple-layout',
    imports: [
        RouterOutlet,
        AdminHeaderComponent,
        FooterComponent],
    templateUrl: './simple-layout.component.html',
    styleUrl: './simple-layout.component.scss'
})
export class SimpleLayoutComponent {

}
